/** Desk /auth/user-info shape (subset used for admin checks). */
export interface DeskUserInfoLike {
  isAdmin?: boolean;
  productRoles?: Array<{ roleName?: string }>;
}

export function isDeskAdmin(userInfo: DeskUserInfoLike | null | undefined): boolean {
  if (!userInfo) {
    return false;
  }
  if (userInfo.isAdmin === true) {
    return true;
  }
  const roles = userInfo.productRoles ?? [];
  return roles.some((role) => role.roleName === 'ادمین');
}
